import React, { useContext, useEffect } from 'react';
import sounds from '@monorepo/shared/src/transformers/genericSounds';
import GWhereDndRound from './components/GWhereDndRound';
import { ActivityContext } from 'state/providers/ActivityProvider';
import { useNativeAudioPlayer } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/AudioManager/hooks/use-native-audio-player';
import { mapAssetsToSrcArray } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/AudioManager/utils';
import type { GuessWhereRound } from '@monorepo/shared/src/graph/schema-generated-types-student';

const GuessWhere: React.FC = () => {
  const [, { load }] = useNativeAudioPlayer();

  const [state, { loadNextRound }] = useContext(ActivityContext);

  const handleOnRoundSuccess = () => {
    if (!state.isLastRound) {
      const round = state.currentRound.round + 1;
      const data = state.activity.rounds[state.currentRound.round];
      loadNextRound(round, data);
      return;
    }
  };

  useEffect(() => {
    const rounds: GuessWhereRound[] = state?.activity?.rounds;
    if (rounds) {
      const roundSounds = rounds.flatMap(({ answer, question, instructions, tiles }) => {
        const tileSounds = tiles.flatMap((t) => [t.audio, t.affirmation]);
        return [answer, question, instructions, ...tileSounds];
      });
      load([sounds.BOINK.src.src, ...mapAssetsToSrcArray(roundSounds)]);
    }
  }, [state?.activity]);

  return (
    <>{state?.currentRound?.round && <GWhereDndRound onRoundSuccess={handleOnRoundSuccess} />}</>
  );
};

export default GuessWhere;
